// Paleta dos planos — fonte única. Antes esta tabela existia em três lugares
// (aqui, em `emailHtml.js` e inline no `DistributionButton.vue`), cada um com um
// formato, e todos indexados pelo NOME DE EXIBIÇÃO. Nome é chave frágil: muda com
// o texto do card e colide entre um plano e seu gêmeo com IA4COM.
//
// A chave agora é o CÓDIGO do plano no billing (`plan.name`), o mesmo que viaja no
// `subscription_item.planName` e no `pricingList`. O gêmeo com IA4COM herda a cor do
// plano base de propósito: quem separa os dois é o rótulo, não a cor.

const BADGE_PALETTE_BY_PLAN_CODE = {
  manager: { background: '#f3f4f6', text: '#374151', border: '#d1d5db' },
  'manager-ia4com': { background: '#f3f4f6', text: '#374151', border: '#d1d5db' },
  support: { background: '#dbeafe', text: '#1d4ed8', border: '#93c5fd' },
  negotiation: { background: '#fef3c7', text: '#b45309', border: '#fcd34d' },
  'negotiation-ia4com': { background: '#fef3c7', text: '#b45309', border: '#fcd34d' },
  unlimited: { background: '#f3e8ff', text: '#7e22ce', border: '#d8b4fe' },
  'unlimited-ia4com': { background: '#f3e8ff', text: '#7e22ce', border: '#d8b4fe' }
}

const DEFAULT_PALETTE = { background: '#f3f4f6', text: '#4b5563', border: '#d1d5db' }

// Ponte para o que ainda chega só com o nome de exibição — hoje o HTML de e-mail
// montado a partir de payload de webhook. Todo caminho novo passa o código.
const PLAN_CODE_BY_DISPLAY_NAME = {
  'Gerencial': 'manager',
  'Gerencial + IA4COM': 'manager-ia4com',
  'Suporte': 'support',
  'Negociação': 'negotiation',
  'Negociação + IA4COM': 'negotiation-ia4com',
  'Ilimitado': 'unlimited',
  'Ilimitado + IA4COM': 'unlimited-ia4com'
}

export const PLAN_CODE_MANAGER = 'manager'

/** Nome de exibição de um plano conhecido pelo código; desconhecido volta como veio. */
export function getPlanDisplayName (planCode) {
  const displayName = Object.keys(PLAN_CODE_BY_DISPLAY_NAME).find(name => PLAN_CODE_BY_DISPLAY_NAME[name] === planCode)
  return displayName === undefined ? planCode : displayName
}

/** Aceita o código ou o nome de exibição e devolve sempre o código. */
export function resolvePlanCode (planCodeOrDisplayName) {
  if (!planCodeOrDisplayName) return null
  if (BADGE_PALETTE_BY_PLAN_CODE[planCodeOrDisplayName]) return planCodeOrDisplayName
  return PLAN_CODE_BY_DISPLAY_NAME[planCodeOrDisplayName] || null
}

/**
 * Paleta do plano. NUNCA devolve null: plano desconhecido cai no cinza neutro.
 * Devolver null aqui era o que deixava o chip sem fundo e com borda sem cor.
 */
export function getPlanPalette (planCodeOrDisplayName) {
  const planCode = resolvePlanCode(planCodeOrDisplayName)
  return BADGE_PALETTE_BY_PLAN_CODE[planCode] || DEFAULT_PALETTE
}

/** Estilo inline do Vue. */
export function getPlanBadgeStyle (planCodeOrDisplayName) {
  const palette = getPlanPalette(planCodeOrDisplayName)
  return { backgroundColor: palette.background, color: palette.text, borderColor: palette.border }
}



// WEBPACK FOOTER //
// ./src/utils/plan-badge.js